var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 22,
    viewBox: "0 0 56 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 22,
    rx: 4,
    fill: "#46CD80"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5469_7817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4167 6.33398H10.3334C10.024 6.33398 9.72725 6.4569 9.50846 6.67569C9.28966 6.89449 9.16675 7.19123 9.16675 7.50065V15.6673C9.16675 15.9767 9.28966 16.2735 9.50846 16.4923C9.72725 16.7111 10.024 16.834 10.3334 16.834H18.5001C18.8095 16.834 19.1062 16.7111 19.325 16.4923C19.5438 16.2735 19.6667 15.9767 19.6667 15.6673V11.584",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7917 5.45814C19.0238 5.22608 19.3386 5.0957 19.6667 5.0957C19.9949 5.0957 20.3097 5.22608 20.5417 5.45814C20.7738 5.6902 20.9042 6.00495 20.9042 6.33314C20.9042 6.66133 20.7738 6.97608 20.5417 7.20814L15.0001 12.7498L12.6667 13.3331L13.2501 10.9998L18.7917 5.45814Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2278 7.428V10.32H31.4438V11.16H28.2278V14.112H31.8038V15H27.1358V6.54H31.8038V7.428H28.2278ZM35.9061 8.328C36.5461 8.328 37.0861 8.488 37.5261 8.808C37.9741 9.128 38.2861 9.556 38.4621 10.092V6.12H39.5541V15H38.4621V13.32C38.2861 13.856 37.9741 14.284 37.5261 14.604C37.0861 14.924 36.5461 15.084 35.9061 15.084C35.3221 15.084 34.8021 14.948 34.3461 14.676C33.8901 14.404 33.5301 14.016 33.2661 13.512C33.0101 13 32.8821 12.4 32.8821 11.712C32.8821 11.024 33.0101 10.424 33.2661 9.912C33.5301 9.4 33.8901 9.008 34.3461 8.736C34.8021 8.464 35.3221 8.328 35.9061 8.328ZM36.2181 9.3C35.5461 9.3 35.0061 9.516 34.5981 9.948C34.1981 10.372 33.9981 10.96 33.9981 11.712C33.9981 12.464 34.1981 13.056 34.5981 13.488C35.0061 13.912 35.5461 14.124 36.2181 14.124C36.6501 14.124 37.0341 14.024 37.3701 13.824C37.7141 13.624 37.9821 13.344 38.1741 12.984C38.3661 12.616 38.4621 12.192 38.4621 11.712C38.4621 11.232 38.3661 10.808 38.1741 10.44C37.9821 10.072 37.7141 9.792 37.3701 9.6C37.0341 9.4 36.6501 9.3 36.2181 9.3ZM41.1 6.48C41.1 6.28 41.168 6.12 41.304 6C41.44 5.872 41.62 5.808 41.844 5.808C42.068 5.808 42.248 5.872 42.384 6C42.52 6.12 42.588 6.28 42.588 6.48C42.588 6.68 42.52 6.844 42.384 6.972C42.248 7.092 42.068 7.152 41.844 7.152C41.62 7.152 41.44 7.092 41.304 6.972C41.168 6.844 41.1 6.68 41.1 6.48ZM42.384 8.412V15H41.292V8.412H42.384ZM47.2837 14.04V15H46.4677C45.7957 15 45.2917 14.84 44.9557 14.52C44.6277 14.2 44.4637 13.664 44.4637 12.912V9.36H43.4797V8.412H44.4637V6.768H45.5677V8.412H47.2717V9.36H45.5677V12.936C45.5677 13.36 45.6437 13.652 45.7957 13.812C45.9557 13.964 46.2277 14.04 46.6117 14.04H47.2837Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5469_7817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(8 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.7a9ec2f26e5300823342ef68c9858ddf.svg";
export { ForwardRef as ReactComponent };